function showErrorMessage() {
    var msg, htmlMsg;
    var userLang = navigator.language || navigator.userLanguage;
    var browsers = ["Internet Explorer 9", "Chrome 35", "Firefox 30", "Safari 7"];
    var errorMsg = v3sWbtPlayerBrowserWarningText;

    var warnDiv = document.getElementById("browserWarn");

    if (!!warnDiv) {
        userLang = userLang.toLowerCase();
        msg = errorMsg["en"];
        for (var lang in errorMsg) {
            if (userLang.indexOf(lang) == 0) {
                msg = errorMsg[lang];
                break;
            }
        }

        htmlMsg = msg + "<ul>";
        for (var i = 0; i < browsers.length; i++) {
            htmlMsg += "<li>" + browsers[i] + "</li>";
        }
        htmlMsg += "</ul>";

        warnDiv.innerHTML = htmlMsg;
        warnDiv.style.display = "block";
    }
}

if (!document.createElement("audio").play) {
    showErrorMessage();
}